var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Carousel'),_c('div',{staticClass:"container"},[_c('PopularRecommend'),_c('RecommendNewSong'),_c('DaySong'),_c('RecommendSinger')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }